// src/utils/loginutils.js
import { supabase } from '../lib/supabaseClient';

export const saveLoginResponse = (data) => {
  try {
    const timestamp = new Date().toISOString();
    const loginHistory = JSON.parse(localStorage.getItem('loginHistory') || '[]');
    
    const loginEntry = {
      timestamp,
      userId: data.user?.id,
      email: data.user?.email,
      lastSignInAt: data.user?.last_sign_in_at,
      sessionData: {
        access_token: data.session?.access_token,
        refresh_token: data.session?.refresh_token,
        expires_at: data.session?.expires_at
      }
    };

    loginHistory.unshift(loginEntry);
    const trimmedHistory = loginHistory.slice(0, 10);
    localStorage.setItem('loginHistory', JSON.stringify(trimmedHistory));
    
    return true;
  } catch (error) {
    console.error('Error saving login response:', error);
    return false;
  }
};

export const getUserProfile = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();

    if (error) throw error;

    // If profile has avatar_url, verify it exists in storage
    if (data?.avatar_url) {
      try {
        const { data: existsData, error: existsError } = await supabase.storage
          .from('avatars')
          .createSignedUrl(data.avatar_url.split('avatars/')[1], 10);

        if (existsError || !existsData) {
          data.avatar_url = null;
          await updateUserProfile(userId, { avatar_url: null });
        }
      } catch (err) {
        console.error('Error verifying avatar:', err);
        data.avatar_url = null;
      }
    }

    return data || {
      id: userId,
      full_name: '',
      avatar_url: null,
      role: 'student',
      bio: '',
      company: '',
      position: '',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

export const updateUserProfile = async (userId, profileData) => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .update(profileData)
      .eq('id', userId)
      .select()
      .single();

    if (error) throw error;
    return data || null;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

export const uploadAvatar = async (userId, file) => {
  try {
    // Validate file
    if (!file || !file.type.startsWith('image/')) {
      throw new Error('Please upload a valid image file');
    }

    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      throw new Error('File size must be less than 5MB');
    }

    // Create unique filename
    const fileExt = file.name.split('.').pop();
    const fileName = `${userId}/${Date.now()}.${fileExt}`;

    // Upload to Supabase storage
    const { data: uploadData, error: uploadError } = await supabase.storage
      .from('avatars')
      .upload(fileName, file, {
        cacheControl: '3600',
        upsert: true
      });

    if (uploadError) throw uploadError;

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('avatars')
      .getPublicUrl(fileName);

    return publicUrl;
  } catch (error) {
    console.error('Error uploading avatar:', error);
    throw error;
  }
};

export const deleteAvatar = async (avatarUrl) => {
  if (!avatarUrl) return;

  try {
    const fileName = avatarUrl.split('avatars/')[1];
    
    if (!fileName) return;

    const { error } = await supabase.storage
      .from('avatars')
      .remove([fileName]);

    if (error) throw error;
  } catch (error) {
    console.error('Error deleting avatar:', error);
    throw error;
  }
};